import { create } from "zustand";

// Persistent record of KOT print failures (BUG-1993/1997/1802 cluster).
// The order/line data itself already made it to the server by the time this
// fires - printToken's axios call is the last, separate step - so this is
// purely a visibility problem: the previous behavior was a message.error
// toast that auto-dismisses in 5s, which a busy waiter/cashier can easily
// miss during a rush, leaving the kitchen with no ticket and no one aware
// there's anything to reprint. Entries here persist until a human dismisses
// them or reprints, via KotPrintFailureBanner.
const useKotPrintFailureStore = create((set) => ({
  failures: [],

  addFailure: (failure) =>
    set((state) => ({
      failures: [
        ...state.failures,
        {
          id: `${Date.now()}_${Math.random().toString(36).slice(2)}`,
          timestamp: Date.now(),
          ...failure,
        },
      ],
    })),

  removeFailure: (id) =>
    set((state) => ({
      failures: state.failures.filter((f) => f.id !== id),
    })),

  clearAllFailures: () => set({ failures: [] }),
}));

export default useKotPrintFailureStore;
